import React from 'react';
import Hero from '../components/Hero';
import FoundingClients from '../components/FoundingClients';
import Problem from '../components/Problem';
import HowItWorks from '../components/HowItWorks';
import DeploymentModel from '../components/DeploymentModel';
import Features from '../components/Features';
import Visibility from '../components/Visibility';
import Capabilities from '../components/Capabilities';
import Industries from '../components/Industries';
import SocialProof from '../components/SocialProof';
import Pricing from '../components/Pricing';
import Comparison from '../components/Comparison';
import ROICalculator from '../components/ROICalculator';
import Guarantee from '../components/Guarantee';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import BookingCalendar from '../components/BookingCalendar';

const Home = () => (
  <div className="bg-white selection:bg-green-900 selection:text-white">
    <Hero />
    <FoundingClients />
    <Problem />
    <HowItWorks />
    <DeploymentModel />
    <Features />
    <Visibility />
    <Capabilities />
    <Industries />
    <SocialProof />
    <Pricing />
    <Comparison />
    <ROICalculator />
    <Guarantee />
    <FAQ />
    <FinalCTA />
    <BookingCalendar />
  </div>
);

export default Home;